import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { RootState } from 'src/store';

import { commonSpacing, theme } from 'src/shared/theme/theme';

import { Box, Button, Typography } from '@mui/material';
import {
  Header,
  Wrapper,
  HeadingSummaryBlock,
  ContentContainerBottom,
  Messages,
  DivWrapper,
} from 'src/components/base/core';
import { WeFoundMatchIcon } from 'src/components/base/core/Media/Icon/Icons/Icons';

export interface ISearchVendor {
  onBackButtonClick?: () => void;
  customer?: string;
  vendor?: string;
  onSubmitEvent?: () => void;
}

export const SearchVendorSuccessContainer = ({
  onBackButtonClick,
  customer,
  vendor,
  onSubmitEvent,
}: ISearchVendor) => {
  const { t } = useTranslation();
  const serverErrors = useSelector((state: RootState) => state.serverError);

  return (
    <Wrapper>
      <DivWrapper className="no_fullscreen">
        <Box
          component={'div'}
          className={'container_content'}
          sx={{
            [`@media(min-width: ${theme.breakpoints.values.sm}px)`]: {
              minHeight: 400 + commonSpacing.desktopPaddingB * 4,
            },
          }}
        >
          <Header isBackButtonVisible={true} onBackButtonClick={onBackButtonClick} paddingX={0} />
          <Box sx={{ marginBottom: 14 }}>
            <HeadingSummaryBlock
              heading={t('headingContent.statusses.weFoundVendor.heading')}
              headingAlignment="left"
              content={t('headingContent.statusses.weFoundVendor.content1', {
                vendor: vendor,
                customer: customer,
              })}
              contentAlignment="left"
            />
            <Typography
              variant="body2"
              sx={{
                textAlign: 'left',
                marginTop: 3,
              }}
            >
              {t('headingContent.statusses.weFoundVendor.content2')}
            </Typography>
            {serverErrors && (
              <Messages messageHeading="Supplier Search" messageContent={serverErrors} />
            )}
          </Box>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              marginBottom: 3,
              color: 'primary.main',
            }}
          >
            <WeFoundMatchIcon />
          </Box>
        </Box>

        <ContentContainerBottom className={'no_fullscreen'}>
          <Button
            variant="containedLarge"
            color="primary"
            type="submit"
            onClick={onSubmitEvent}
            fullWidth
            sx={{ overflow: 'hidden' }}
          >
            {t('buttonTexts.continueButton')}
          </Button>
        </ContentContainerBottom>
      </DivWrapper>
    </Wrapper>
  );
};
